import { useQuery } from '@tanstack/react-query';
import { getMainCompany } from 'api/companies';
import { companyKeys } from 'api/queryKeys';
import { SESSION_KEY } from 'hooks/queries/useMeQuery';

const hasSession = () =>
  typeof window !== 'undefined' && !!localStorage.getItem(SESSION_KEY);

export const useMainCompanyQuery = () =>
  useQuery({
    queryKey: companyKeys.main(),
    queryFn: () => getMainCompany().then((res) => res.data),
    enabled: hasSession(),
    retry: false
  });
